export default {
  methods: {
    collect_meta_pairs(sections) {
      const collected = [];
      sections.forEach((section) => {
        this.sanitized_section_descriptions(section).forEach((line) => {
          const pair = this.parse_key_value(line);
          if (pair) collected.push(pair);
        });
      });
      return collected;
    },

    extract_preview_meta(sections = []) {
      if (!Array.isArray(sections)) return [];
      const collected = this.collect_meta_pairs(sections);
      const seen = new Set();
      return collected.filter((item) => {
        const key = item.label.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      }).slice(0, 8);
    },

    map_column_entry(entry, index) {
      if (typeof entry === 'string') {
        const pair = this.parse_key_value(entry);
        if (pair) return { title: pair.label, body: pair.value };
        return { title: `Item ${index + 1}`, body: entry };
      }
      if (entry && typeof entry === 'object') {
        const title = entry.title || entry.label || `Item ${index + 1}`;
        const body = entry.value || entry.description || entry.text || '';
        return { title, body };
      }
      return null;
    },

    section_column_cards(section) {
      const raw = Array.isArray(section?.columns) ? section.columns : [];
      return raw.map((e, i) => this.map_column_entry(e, i)).filter((c) => c && (c.title || c.body));
    },

    has_string_content(section_data) {
      return (section_data || '').trim().length > 0;
    },

    has_array_content(section_data) {
      return section_data.length > 0 && section_data.some(item => {
        if (typeof item === 'string') return item.trim().length > 0;
        if (typeof item === 'object' && item !== null) {
          return Object.values(item).some(v => v && String(v).trim().length > 0);
        }
        return !!item;
      });
    },

    has_object_content(section_data) {
      return Object.values(section_data).some(v => v && String(v).trim().length > 0);
    },

    section_has_content(section_key) {
      if (!this.parsed_document) return false;
      const section_data = Reflect.get(this.parsed_document, section_key);
      
      if (section_data === null || section_data === undefined) return false;
      
      if (typeof section_data === 'string') return this.has_string_content(section_data);
      if (Array.isArray(section_data)) return this.has_array_content(section_data);
      if (typeof section_data === 'object') return this.has_object_content(section_data);
      
      return !!section_data;
    },
  },
};
